import styled from 'styled-components';
import RawContent from 'common/RawContent';
import { pxToRem } from 'utils/stylingUtils';

const StyledRawContent = styled(RawContent)`
    margin: ${pxToRem(6)} 0;
`;

export default StyledRawContent;
